<template>
  <div class="share-third">
    <div class="share-third-main" ref="main">
      <div class="share-top">
        <img src="../assets/img/share/jpg-hongbao@2x.png" alt />
        <div>
          邀请好友购买，您即可获得高收益
        </div>
      </div>
      <div class="share-card-main" id="share-card-main">
        <img class="bg-img" :src="shopPoster" alt />
      </div>
      <div class="save-hint">
        长按图片，保存到手机相册
      </div>
      <div id="box"></div>
    </div>
  </div>
</template>

<script>
import html2canvas from "html2canvas";
import { Toast } from "vant";
import vueQr from "vue-qr";
import api from "../api/api";
export default {
  components: {
    vueQr,
  },
  props: ["shareData", "courseDetails"],
  data() {
    return {
      userInfo: "",
      link: "",
      shopName: "",
      verifyCode: "",
      profit:0,
      productId:0,
      productName:'',
      productImg:'',
      productBase: '',
      userDetail:{},
      shopId:0,
      qrCode:'',
      shopPoster: '',
    };
  },
  methods: {
    //获取用户详细信息
    getUserDetail(){
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api.getUserInfo().then(res=>{
        this.userDetail = res.data;
          let pathData = ''
          if (this.productId === '' || this.productId == undefined){
            pathData = 'pages/switch/h5/toH5'+'?page='+'shop'+'&shopId='+this.shopId+'&inviteCode='+this.userDetail.inviteCode+'&visite=1'
          }else {
            pathData = 'pages/switch/h5/toH5'+'?page='+'courseDetails'+'&productId='+this.productId+'&shopId='+this.shopId+'&inviteCode='+this.userDetail.inviteCode+'&visite=1'
          }
          //获取二维码
          let params = {
            path:pathData
          }
          api.getQrCode(params).then(res=>{
              this.qrCode = res.data;
              this.getPoster();
          }).catch(err=>{
              console.log("err ",err)
          })
      }).catch(err=>{
        console.log(err)
      })
    },
    // 获取海报
    getPoster(){
      let params = {
        templateName: 'fastShopPoster',
        qrCodeUrl: this.qrCode,
        shopId: this.shopId,
        productId: this.productId
      }
      api.getPoster(params).then(res=>{
        if(res.success){
          this.shopPoster = res.data;
          console.log(res.data);
          let img = document.createElement("img");
          img.src = res.data;
          img.style = "width:100%;"
          document.getElementById("box").appendChild(img);
          Toast.clear();
        }else{
          Toast(res.msg);
          return;
        }
      }).catch(err=>{
        Toast('系统错误!');
      });
    },
  },
  created() {
    document.title = "分享";
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.shopName = localStorage.getItem("shopName");
    this.profit = this.$route.query.profit;
    this.shopId = this.$route.query.shopId;
    this.shopName = this.$route.query.shopName;
    this.productId = this.$route.query.productId;
    this.productName = this.$route.query.productName;
    this.productImg = this.$route.query.productImg;
    this.getUserDetail();
  },
};
</script>

<style lang="scss" scoped>
.share-third {
  width: 100%;
  min-height: 100vh;
  background-color:#F8F8F8;
  z-index: 100;
  .share-third-main {
    // height: 100vh;
    padding-top: 10%;
  }
  .share-top {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0.4rem;
    img {
      width: 30px;
    }
    div {
      margin-left: 0.625rem;
      color: #333;
      font-size: 15px;
      white-space: nowrap;
      span {
        color: #ff3f1b;
      }
    }
  }
  .share-card-main {
    position: relative;
    width: 86%;
    height: 30rem;
    margin: 0 auto;
    .bg-img {
      width: 100%;
      height: 100%;
    }
    .share-card-bto {
      position: absolute;
      left: 50%;
      bottom: 9.4%;
      width: 74%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .save-hint{
    margin-top: 1.5rem;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
    }
  .save-btn {
    display: flex;
    flex-direction: column;
    color: #fff;
    // justify-content: center;
    align-items: center;
    margin-top: 0.6rem;
    img {
      width: 2.5rem;
    }
    div {
      margin-top: 0.4rem;
      font-size: 14px;
      color: #fff;
    }
  }
  .share-poster-bto {
    // position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    padding: 12px 0;
    justify-content: space-around;
    background-color: #fff;
    box-sizing: border-box;
    .share-friend {
      img {
        width: 36px;
      }
      div {
        font-size: 14px;
        color: #666666;
      }
    }
  }
}
#box {
    position: absolute;
    top: 12%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 200;
    opacity: 0;
    width: 20.125rem;
    height: 30.125rem;
    img {
      width: 20.125rem;
      height: 30.125rem;
      vertical-align: middle;
      border-radius: 12px;
    }
  }
</style>
